// extracted by mini-css-extract-plugin
export default {"crmContainer":"oC_ZlofJmf45I7QAUIoe__crmContainer___"};